import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FlexContainer, Spinner, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { userStageSelector } from 'Store/modules/validations/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import {
  useFetchFilingUser,
  usePatchFilingUser,
  useSubmitDeclarationCrossSell,
} from 'Containers/Filing/hooks';
import FlowColLayout from 'Components/Layouts/FlowColLayout';
import { routes } from 'Constants/routes';
import { stages } from 'Constants/stages';
import ClabeInput from './components/ClabeInput';
import * as Styled from './styles';

const ClabeFormPreFiling = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const info = useSelector(routeStateSelector);
  const userStage = useSelector(userStageSelector);
  const { mutate, isLoading } = usePatchFilingUser();
  const { mutate: submitDeclaration } = useSubmitDeclarationCrossSell();
  const { isLoading: loading, data } = useFetchFilingUser();

  useEffect(() => {
    if (!info?.userPlan || userStage === stages.SUBMITTED) {
      history.push(routes.DASHBOARD);
    }
  }, [info, userStage]);

  const handleSubmit = (clabe?: string): void => {
    mutate(
      { CLABE: clabe },
      {
        onSuccess: () => {
          submitDeclaration({});
        },
      }
    );
  };

  return (
    <FlowColLayout section="result" isFlow>
      {isLoading || loading || !data ? (
        <FlexContainer justify="center" align="center" fullWidth>
          <Spinner size="M" justify="center" align="center" />
        </FlexContainer>
      ) : (
        <FlexContainer fullWidth justify="center">
          <Styled.ClabeContent direction="column" gap="dimension_16">
            <Text type="headline" size="XS_L_S" color="dark">
              {t('PreFiling.clabe.title')}
            </Text>
            <Text type="paragraphs" size="M_S_S" color="dark">
              {t('PreFiling.subtitle')}
            </Text>
            <ClabeInput handleSubmit={handleSubmit} data={data} />
          </Styled.ClabeContent>
        </FlexContainer>
      )}
    </FlowColLayout>
  );
};

export default ClabeFormPreFiling;
